import { render, staticRenderFns } from "./yc-annals-target-details.vue?vue&type=template&id=871c976a&scoped=true&"
import script from "./yc-annals-target-details.vue?vue&type=script&lang=js&"
export * from "./yc-annals-target-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871c976a",
  null
  
)

export default component.exports